/* tslint:disable */
/* eslint-disable */
/**
 * OpenAPI definition
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: v0
 *
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */
import { NoteDtoFromJSON, NoteDtoToJSON, } from './NoteDto';
/**
 * Check if a given object implements the ListNoteDto interface.
 */
export function instanceOfListNoteDto(value) {
    return true;
}
export function ListNoteDtoFromJSON(json) {
    return ListNoteDtoFromJSONTyped(json, false);
}
export function ListNoteDtoFromJSONTyped(json, ignoreDiscriminator) {
    if (json == null) {
        return json;
    }
    return {
        'note': json['note'] == null ? undefined : (json['note'].map(NoteDtoFromJSON)),
    };
}
export function ListNoteDtoToJSON(value) {
    if (value == null) {
        return value;
    }
    return {
        'note': value['note'] == null ? undefined : (value['note'].map(NoteDtoToJSON)),
    };
}
